<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="活动标题">
        <a-input
          type="text"
          style="width: 600px"
          v-model="form.name"
        ></a-input>
      </a-form-item>
      <a-form-item label="活动Logo">
        <UploadFile v-if="show_editor" @callback="uploaded" :mult="false" folder="activity" />
        <img style="max-height: 100px" :src="this.API + form.logo" alt="">
      </a-form-item>
      <a-form-item label="活动海报">
        <UploadFile v-if="show_editor" @callback="uploaded2" :mult="false" folder="activity" />
        <img style="max-height: 200px" :src="this.API + form.thumb" alt="">
      </a-form-item>
      </a-form-item>
      <a-form-item label="活动简介">
        <a-textarea
          style="width: 600px"
          :auto-size="{ minRows: 3, maxRows: 6 }"
          v-model="form.desc"
        />
      </a-form-item>
      <a-form-item label="选择位置">
        <a-button size="small" icon="compass" @click="pos_picker_show = true"></a-button>
        {{form.lat}}<span v-if="form.lng">,</span>{{form.lng}}
      </a-form-item>
      <a-form-item label="贝展场地">
        <a-input style="width: 600px" type="text" v-model="form.place"></a-input>
      </a-form-item>
      <a-form-item label="详细地址">
        <a-input style="width: 600px" type="text" v-model="form.addr"></a-input>
      </a-form-item>
      <a-form-item label="主办方">
        <a-input style="width: 600px" type="text" v-model="form.zhuban" placeholder="多个主办方用中文、隔开"></a-input>
      </a-form-item>
      <a-form-item label="协办方">
        <a-input style="width: 600px" type="text" v-model="form.xieban" placeholder="多个协办方用中文、隔开"></a-input>
      </a-form-item>
      <a-form-item label="报名费">
        <a-input-number :min="0" v-model="form.fee"></a-input-number>
      </a-form-item>
      <a-form-item label="活动时间">
        <a-date-picker :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }" v-model="form.start_at" />
        <span style="margin: 0 10px">-</span>
        <a-date-picker :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }" v-model="form.end_at" />
      </a-form-item>
      <a-form-item label="报名时间">
        <a-date-picker :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }" v-model="form.join_start" />
        <span style="margin: 0 10px">-</span>
        <a-date-picker :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }" v-model="form.join_end" />
      </a-form-item>
      <a-form-item label="限制总人数">
        <a-input-number :min="0" style="width: 320px" v-model="form.amount_limit" placeholder="请输入数字"></a-input-number>
        <div class="tips">本活动总限制人数，0为不限制</div>
      </a-form-item>
      <a-form-item label="报名限制">
        <a-input-number :min="1" style="width: 320px" v-model="form.join_limit" placeholder="请输入数字"></a-input-number>
        <div class="tips">每人限制最多报几个名额</div>
      </a-form-item>
      <a-form-item label="需要报名">
        <a-radio-group v-model="form.need_join">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="需要审核">
        <a-radio-group v-model="form.need_app">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="邀请报名">
        <a-radio-group v-model="form.yaoqing">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="优惠券">
        <a-select style="width: 320px" v-model="form.coupon_id" @change="selectCoupon">
          <a-select-option :value="0">请选择</a-select-option>
          <a-select-option v-for="(coupon, c) in couponList" :key="c" :value="coupon.id">{{coupon.name}} （满{{coupon.man}}减{{coupon.jian}}）</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="详细介绍">
        <Editor
          v-if="show_editor"
          @callback="updateEditor"
          :data="form.content"
          folder="activity"
        />
      </a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="sub">提交修改</a-button>
    </div>

    <PosPicker v-if="pos_picker_show" @callback="gotPosition" />
  </div>
</template>

<style lang="scss" scoped>
.tips {
  font-size: 12px;
  color: red;
}
</style>

<script>
import moment from "moment";
import UploadFile from "../../components/uploadFile";
import Editor from "../../components/editor";
import PosPicker from "../../components/posPicker";

export default {
  components: { UploadFile, Editor, PosPicker },
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      couponList: [],
      form: {
        exh_id: 0,
        name: "",
        logo: "",
        thumb: "",
        desc: "",
        content: "",
        place: "",
        addr: "",
        lat: "",
        lng: "",
        zhuban: "",
        xieban: "",
        fee: 0,
        start_at: null,
        end_at: null,
        join_start: null,
        join_end: null,
        need_join: 1,
        need_app: 0,
        amount_limit: 0,
        join_limit: 1,
        yaoqing: 0
      },
      show_editor: false,
      pos_picker_show: false,
    };
  },
  async created() {
    const id = this.$route.query.id;
    const r = await this.$axios.get("/activity/getInfo?id=" + id);
    if (r.status == 1) {

      if(r.info.start_at){
        r.info.start_at = moment(r.info.start_at)
      }
      else{
        r.info.start_at = null;
      }

      if(r.info.end_at){
        r.info.end_at = moment(r.info.end_at)
      }
      else{
        r.info.end_at = null;
      }
// 
      if(r.info.join_start){
        r.info.join_start = moment(r.info.join_start)
      }
      else{
        r.info.join_start = null;
      }

      if(r.info.join_end){
        r.info.join_end = moment(r.info.join_end)
      }
      else{
        r.info.join_end = null;
      }

      if(!r.info.coupon_id) r.info.coupon_id = 0; 
      this.form = r.info;

      this.show_editor = true
    }
    // 获取优惠券
    const r2 = await this.$axios.get('/activity/getCouponList');
    this.couponList = r2.list;
  },
  methods: {
    moment,
    async sub() {
      const form = { ...this.form }
      form.start_at = moment(form.start_at).valueOf()
      form.end_at = moment(form.end_at).valueOf()
      form.join_start = moment(form.join_start).valueOf()
      form.join_end = moment(form.join_end).valueOf()

      const r = await this.$axios.post('/activity/doUpdate', form);
      if(r.status == 1) this.$router.back()
    },

    uploaded(file) {
      this.form.logo = file.file_path;
    },

    uploaded2(file) {
      this.form.thumb = file.file_path;
    },

    updateEditor(data) {
      this.form.content = data;
    },

    gotPosition(pos) {
      this.pos_picker_show = false;
      this.form.place = pos.poiname;
      this.form.addr = pos.poiaddress;
      this.form.lat = pos.latlng.lat;
      this.form.lng = pos.latlng.lng;
    },

    selectCoupon () {
      for(let item of this.couponList){
        if(item.id == this.form.coupon_id){
          this.form.coupon_name = item.name
          break
        }
      }
    }
  },
};
</script>